import classNames from 'classnames'
import { IWidgetHeaderProps } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/models'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './WidgetHeader.module.scss'

export const WidgetHeader = ({
  children,
  className,
  text,
  content,
  align = 'center',
}: IWidgetHeaderProps) => {
  return (
    <header
      className={classNames(styles.header, { [styles[`align-${align}`]]: align }, className || '')}
    >
      <Translation text={children} span={true} />
      {text && <span>{text}</span>}
      {content && content()}
    </header>
  )
}
